import { render, staticRenderFns } from "./MessagingListsList.vue?vue&type=template&id=b26dfc0c&scoped=true&"
import script from "./MessagingListsList.vue?vue&type=script&lang=js&"
export * from "./MessagingListsList.vue?vue&type=script&lang=js&"
import style0 from "./MessagingListsList.vue?vue&type=style&index=0&id=b26dfc0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26dfc0c",
  null
  
)

export default component.exports